if (!customElements.get('vics-artwork-information')) {
  customElements.define('vics-artwork-information', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.tabs = [...this.querySelectorAll('[data-artwork-tab]')];
      this.groups = [...this.querySelectorAll('[data-artwork-group]')];
      this.selected = this.groups.find(group => group.dataset.artworkGroup === this.dataset.defaultTab)?.dataset.artworkGroup || this.groups[0]?.dataset.artworkGroup;
      this.desktop = matchMedia('(min-width: 990px)');
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.artworkTab), { signal });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.activate(this.tabs[next].dataset.artworkTab);
          this.tabs[next].focus();
        }, { signal });
      });
      this.querySelector('[data-artwork-size-guide]')?.addEventListener('click', () => {
        document.querySelector('.product-information [data-vics-size-guide]')?.click();
      }, { signal });
      document.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        if (!link) return;
        const url = new URL(link.href, location.href);
        if (url.origin === location.origin && url.pathname === location.pathname && ['#vics-product-reviews', '#looxReviews'].includes(url.hash)) this.activate('reviews');
      }, { signal });
      window.addEventListener('hashchange', () => this.openLinkedReviews(), { signal });
      this.desktop.addEventListener('change', () => this.syncLayout(), { signal });
      // Keep Loox's server-rendered reviews readable until its full widget is ready.
      const reviewPanel = this.querySelector('[data-artwork-panel="reviews"]');
      const reviewWidget = reviewPanel?.querySelector('#looxReviews');
      if (reviewWidget) {
        const syncReviewPreview = () => {
          const frame = reviewWidget.querySelector('#looxReviewsFrame');
          // Loox reports the rendered content height after the iframe is ready.
          if (frame && Number.parseFloat(frame.getAttribute('height')) > 300) {
            reviewPanel.classList.add('is-review-widget-ready');
            this.reviewObserver?.disconnect();
          }
        };
        this.reviewObserver = new MutationObserver(syncReviewPreview);
        this.reviewObserver.observe(reviewWidget, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['height', 'style'],
        });
        syncReviewPreview();
      }
      this.syncLayout();
      this.openLinkedReviews();
    }
    disconnectedCallback() {
      this.reviewObserver?.disconnect();
      this.reviewObserver = null;
      this.controller?.abort();
      this.controller = null;
    }
    syncLayout() {
      this.classList.toggle('is-desktop', this.desktop.matches);
      this.querySelector('[role="tablist"]').hidden = !this.desktop.matches;
      this.querySelectorAll('[data-artwork-panel]').forEach(panel => {
        if (this.desktop.matches) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.artworkTab === panel.dataset.artworkPanel).id);
          panel.tabIndex = 0;
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
          panel.removeAttribute('tabindex');
        }
      });
      this.activate(this.selected);
    }
    activate(key) {
      if (!this.groups.some(group => group.dataset.artworkGroup === key)) return;
      this.selected = key;
      this.tabs.forEach(tab => {
        const active = tab.dataset.artworkTab === key;
        if (tab.getAttribute('aria-selected') !== String(active)) tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.groups.forEach(group => {
        const active = group.dataset.artworkGroup === key;
        if (this.desktop.matches && group.open !== active) group.open = active;
        else if (active && !group.open) group.open = true;
      });
    }
    openLinkedReviews() {
      if (['#vics-product-reviews', '#looxReviews'].includes(location.hash)) this.activate('reviews');
    }
  });
}
